<template>
  <header>
    <div class="linha">
      <div class="coluna">
        <nav class="jm jm-menu nav-maior none" id="menu">
          <div class="separador">
            <a v-for="modulo in menus" v-bind:key="modulo.id" :href="modulo.URL"
              :class="moduleName == modulo.nome ? 'ativo' : ''">{{ modulo.nome }}</a>
          </div>
        </nav>
        <a :href="linkPortal" class="logo logo-menor">Thalamus</a>
        <a href="#" class="icone-avancar negrito com-texto"
          onclick="document.getElementById('menu').classList.toggle('none');this.classList.toggle('ativo');return false">
          {{ moduleName }}</a>
      </div>

      <div class="coluna">

        <a href="#" class="avatar direita"
          onclick="document.getElementById('usuario').classList.toggle('none');this.classList.toggle('ativo');return false"
          :title="user.nome">
          <img
            class="avatar-img"
            :class="{ 'avatar-img--placeholder': !pessoa.path_image }"
            :style="{ filter: theme == 'dark' && !pessoa.path_image ? 'invert(100%)' : null }"
            :src="baseUrl + pessoa.path_image || 'https://cdn-icons-png.flaticon.com/128/709/709722.png'" />
        </a>

        <nav class="jm jm-avatar none" id="usuario">
          <div class="separador margem alinha-centro negrito">
            {{ user.nome }}
          </div>
          <div class="separador">
            <a :href="linkDadosCadastrais">Dados Cadastrais</a>

            <a href="#" :class="theme == 'dark' ? 'ativo' : ''"
              onclick="document.documentElement.classList.toggle('dark');this.classList.toggle('ativo');return false"
              @click="setTheme()"><span class="direita toggle"></span>Tema escuro</a>
            <a>
              <ResetPasswordTile />
            </a>
          </div>
          <div class="separador bg-cinza">
            <a :href="linkPortal + 'login'" @click="logout()">Sair</a>
          </div>
        </nav>
        <div v-if="notificacoes.length == 0">
          <a href="#" class="icone-notif direita" title="Notificacoes" style="box-sizing: unset"
            onclick="document.getElementById('notificacoes').classList.toggle('none');this.classList.toggle('ativo');return false"></a>

          <nav class="jm jm-notif none" id="notificacoes">
            <div class="separador">
              <div class="fonte-fraca">Nenhuma notificação</div>
            </div>
          </nav>
        </div>
        <div v-if="notificacoes.length !== 0">
          <a href="#" class="icone-notif direita" title="Notificacoes" style="box-sizing: unset"
            :rel="notificacoes.length"
            onclick="document.getElementById('notificacoes').classList.toggle('none');this.classList.toggle('ativo');return false"></a>
          <nav class="jm jm-notif none" id="notificacoes" style="width: 380px !important;">
            <div class="separador" style="max-height: 400px; overflow-y: auto">
              <div v-for="(notif, index) in notificacoes" :key="index">
                <div style="display: flex; flex-direction: row">
                  <div @click="lerNotificacao(notif)" style="padding: 10px 0px 0px 10px; margin: 0; width: 100%;">
                    <p :style="{ 'opacity': (notif.status ? '0.5' : '') }" class="texto">
                      {{ notif.msg }}
                    </p>
                  </div>
                  <div class="fonte-menor fonte-fraca"
                    style="display: flex; flex-flow: column; justify-content: space-between; align-items: end; padding: 10px 0px 0px 10px;">
                    <i class="bi-x-circle" title="Apagar notificação" @click="apagarNotificacao(notif)"></i>
                    <div style="text-align: right; white-space: nowrap; display: flex; align-items: flex-end;">
                      {{ timeSince(notif) }}
                    </div>
                  </div>
                </div>
                <hr style="border: 1px solid #ddd; margin: 3px 0" />
              </div>
            </div>
            <span class="chip fonte-fraca direita" style="margin-bottom: 5px; margin-top: auto"
              @click="apagarNotificacoesLidas">Limpar lidas</span>
            <span class="chip fonte-fraca direita bg-erro" style="margin-bottom: 5px; margin-top: auto; cursor: pointer"
              @click="apagarTodasNotificacoes">Apagar Todas</span>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { sso } from "roboflex-thalamus-sso-lib";
import headerMenuService from "@/services/headerMenuService";
import { ref } from "vue";
import { NotificationService } from "../services/notificationServices";
import ResetPasswordTile from "./ResetPasswordTile.vue";

export default {
  name: "HeaderComponent",
  components: {
    ResetPasswordTile,
  },
  data() {
    return {
      user: null,
      pessoa: {},
      theme: null,
      notificacoes: [],
      baseUrl: 'https://api.thalamus.ind.br/storage/',
      notifService: new NotificationService(this.buildMode),
    };
  },

  mounted() {
    this.getPessoa();
    this.getNotificacoes(this.buildMode);
  },

  props: {
    moduleName: {
      type: String,
      default: "",
      required: true,
    },
    buildMode: {
      type: String,
      default: "",
      required: true,
    },
  },
  computed: {
    getModuleName() {
      return this.moduleName;
    },
  },

  async created() {
    this.user = sso.getUsuarioLogado();
    this.theme = localStorage.getItem("tema");
    if (this.theme == null) {
      localStorage.setItem("tema", "light");
    } else {
      document.documentElement.classList.toggle(this.theme);
    }
  },

  setup(props) {
    let linkPortal = ref();
    let menus = ref(new Array());
    let linkDadosCadastrais = ref();

    const carregarModulos = async () => {
      let modulos = await headerMenuService.buscarModulos(props.buildMode);
      menus.value = modulos;
    };
    carregarModulos();

    linkPortal.value = headerMenuService.linkPortal(props.buildMode);
    linkDadosCadastrais.value = headerMenuService.linkDadosCadastrais(props.buildMode);

    return {
      linkPortal,
      menus,
      linkDadosCadastrais,
    };
  },
  methods: {
    async getPessoa() {
      this.pessoa = await headerMenuService.getPessoa();
    },
    logout() {
      sso.logout();
    },

    setTheme() {
      if (this.theme == "light") {
        localStorage.setItem("tema", "dark");
        this.theme = "dark";
      } else {
        localStorage.setItem("tema", "light");
        this.theme = "light";
      }
    },

    async apagarNotificacoesLidas() {
      var ids = this.notificacoes.filter(i => i.status == 1).map((item) => item.id);
      var response = await this.notifService.apagarNotificacoes(ids);
      if (response) {
        this.notificacoes = this.notificacoes.filter(i => i.status != 1);
      }
    },

    async apagarTodasNotificacoes() {
      if (this.notificacoes.length === 0) return;
      var ids = this.notificacoes.map((item) => item.id);
      var response = await this.notifService.apagarNotificacoes(ids);
      if (response) {
        this.notificacoes = [];
      }
    },

    async apagarNotificacao(notif) {
      var response = await this.notifService.apagarNotificacoes([notif.id]);
      if (response) {
        this.notificacoes = this.notificacoes.filter((n) => n.id !== notif.id);
      }
    },

    async lerNotificacao(notif) {
      var url = this.buildMode == 'development' ? 'http://projetos-homologacao.thalamus.ind.br/#/' : 'https://projetos.thalamus.ind.br/#/'
      await this.notifService.lerNotificacao([notif.id]);
      if (notif.tipo == 'EntregasProjeto') {
        window.open(`${url}projeto/${notif.info.projeto_id}`, '_blank')
      }
      if (notif.tipo == 'SprintTarefa' && notif.info?.projeto_id) {
        const params = new URLSearchParams();
        if (notif.info.entrega_id) params.set('entrega_id', notif.info.entrega_id);
        if (notif.info.sprint_id) params.set('sprint_id', notif.info.sprint_id);
        if (notif.info.id) params.set('destaque_tarefa_id', notif.info.id);
        const query = params.toString();
        window.open(`${url}projeto/${notif.info.projeto_id}${query ? '?' + query : ''}`, '_blank')
      }
      if (notif.tipo == 'ProtocoloTarefa' && notif.info?.protocolo_id) {
        const tipoId = notif.info.protocolo_tipo_id;
        const protocoloId = notif.info.protocolo_id;
        const params = new URLSearchParams();
        if (notif.info.id) params.set('destaque_tarefa_id', notif.info.id);
        const query = params.toString();
        let path = tipoId == 6 ? `grupo/${protocoloId}` : tipoId == 7 ? `reuniao/${protocoloId}` : `protocolo/${protocoloId}`;
        window.open(`${url}${path}${query ? '?' + query : ''}`, '_blank')
      }
      if (notif.tipo === 'OrdemServico2' && notif.info?.id) {
        const path = notif.info.rota_demandas || `ordem-servico/${notif.info.id}/editar-assistencia`;
        window.open(`${window.location.origin}/#/${path}`, '_blank');
      }
      this.getNotificacoes()
    },

    async getNotificacoes() {
      let response = await this.notifService.getNotificacoes();

      this.notificacoes = response.data.sort((a, b) => {
        const dateA = new Date(a.info?.created_at || "1970-01-01T00:00:00Z");
        const dateB = new Date(b.info?.created_at || "1970-01-01T00:00:00Z");
        return dateB - dateA;
      });
    },

    timeSince(notif) {
      if (!notif || !notif.info || !notif.info.created_at) {
        return "Sem data";
      }
      const createdAt = notif.info.created_at;
      const diferença = new Date() - new Date(createdAt);
      const diferençaMinutos = Math.floor(diferença / (1000 * 60));
      const diferençaHoras = Math.floor(diferença / (1000 * 60 * 60));
      const diferençaDias = Math.floor(diferença / (1000 * 60 * 60 * 24));

      if (diferençaMinutos < 60) {
        return `${diferençaMinutos} min`;
      } else if (diferençaHoras < 24) {
        return `${diferençaHoras} h`;
      } else {
        return `${diferençaDias} ${diferençaDias > 1 ? "dias" : "dia"}`;
      }
    },
  },
};
</script>

<style>
.jm-notif {
  max-width: 380px !important;
}

.chip {
  cursor: pointer;
}

.texto {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  cursor: pointer;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.white-profile {
  filter: invert(100%) !important;
}

/* Avatar: círculo fixo + object-fit para não distorcer a foto */
.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-top: 3px !important;
  border: 1px solid var(--cor-primaria);
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 1.2px !important;
}

.avatar .avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.avatar .avatar-img--placeholder {
  object-fit: contain;
  padding: 8px;
}

a:not(.avatar) > img {
  height: 36px !important;
  width: 36px !important;
}

.bi-x-circle {
  cursor: pointer;
  color: var(--cor-erro);
  font-size: 16px;
}

.bi-x-circle:hover {
  transition: all 200ms ease-in;
  font-size: 18px;
}
</style>
